import { useAnalytics } from "@/lib/analytics/analytics";
import { TrackProperties } from "@/lib/analytics/types";
import { usePartnerQuery } from "@/offering/api";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { PortalPathParams } from "./use_portal_history";
import { useSubscriptionDetailsQuery } from "./use_subscription_details_query";

export function useMembershipManagementAnalytics() {
  const analytics = useAnalytics();
  const { subscriptionId, partnerSlug } = useParams<PortalPathParams>();
  const partner = usePartnerQuery(partnerSlug);
  const { data: subscriptionDetails } = useSubscriptionDetailsQuery(
    partner.id,
    subscriptionId
  );

  return useCallback(
    (event: string, properties?: TrackProperties) => {
      if (
        subscriptionDetails?.membership.id &&
        subscriptionDetails.membership.name
      ) {
        analytics.event(event, {
          Source: "Portal",
          "Partner UUID": partner.id,
          "Partner Name": partner.name,
          "Partner Internal Name": partner.internalName,
          "Membership UUID": subscriptionDetails.membership.id,
          "Membership Name": subscriptionDetails.membership.name,
          ...properties,
        });
      }
    },
    [
      subscriptionDetails?.membership.id,
      subscriptionDetails?.membership.name,
      analytics,
      partner.id,
      partner.internalName,
      partner.name,
    ]
  );
}
